import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { LoadingSpinner, observable } from 'legacy-packages/ft-cb';
import LearnosityItemTags from 'legacy-src/utility/LearnosityItemTags';
import ItemTags from 'legacy-src/utility/ItemTags';
import ResponsiveView, { MobileMedia } from 'legacy-src/utility/ResponsiveView';
import { LearnosityPlayer } from 'legacy-learnosity-player';
import { largeFontSubjects } from 'legacy-src/constants/assignment';
import LearnosityItemPreview from 'legacy-src/components/learnosity/LearnosityItemPreview';
import annotationRequests from 'legacy-src/components/apstudent/handlers/ReadinessCheck/annotationData';
import isAudioCheckEnabled from 'legacy-src/utility/isAudioCheckEnabled';
import PlayerGuidelines from './PlayerGuidelines';
import cn from 'classnames';
import { setMathJaxTypeset } from 'chameleon-src/utility/utils';

import './index.scss';

class PreviewPlayer extends PureComponent {
  static displayName = 'Player';

  static propTypes = {
    subjectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    displayTags: PropTypes.bool,
    navigation: PropTypes.element,
    // currently used on QB -> Create preview to jump to the correct question on the player
    params: PropTypes.object,
  };

  static defaultProps = {
    learnosityConfig: {},
    questions: [],
    displayTags: true,
    navigation: null,
    params: { previewId: null },
    loadingAssignmentData: true,
    loadingQuestionData: true,
  };

  state = {
    itemLoading: false,
    toogleStatus: false,
    isMetaDataPanelExpanded: false,
  };

  componentWillUnmount() {
    observable.emit('preview-player-unmounted', true);
  }

  readyListenerCallback = (questionId, isFirst) => {
    const { location, router, onQuestionChanged, params } = this.props;
    const {
      pathname,
      query: { newQuestionItemId = null },
    } = location;
    const { previewId } = params;
    const questionIdToGoTo = newQuestionItemId || previewId || questionId;

    if (!isFirst) {
      router.push({
        query: { ...location.query, item: questionIdToGoTo },
        pathname,
      });
    }

    if (onQuestionChanged) {
      onQuestionChanged(questionIdToGoTo);
    }
  };

  handleQuestionDetailsToogleRationale = (toogleStatus) => {
    this.setState({ toogleStatus });
  };

  handleToggleExpansion = (isMetaDataPanelExpanded) => {
    this.setState({
      isMetaDataPanelExpanded,
    });
  };

  render() {
    const {
      loading,
      subjectId,
      itemId,
      assignmentId,
      location,
      learnosityServerData,
      questions,
      displayTags,
      subjectData = {},
      allowCalculatorForItems,
      navigation,
      showQuestionInfo,
      showQuestionOverview,
      showQuestionIndex,
      showQuestionBookmark,
      showCalculatorAllowedIcon,
      isSingleQuestionPreview,
      onQuestionChanged,
      children,
      userData: { isStudent },
      params: urlParams,
      hasTeacherAnnotation,
      showUpdatedCharmBraceletAP,
      showUpdatedCharmBraceletPreAP,
      isFinalExam,
      isReordering,
      onOrderChange = () => {},
      showGrayTopRightBarPreview,
      enableAudioPlaybackComplete,
      showDoubleArrow,
      className,
    } = this.props;

    const { isPreApSubject = false, id: masterSubjectId = '' } = subjectData;

    const { item: questionIdQuery, newQuestionItemId = null } = location.query;
    const { itemLoading, toogleStatus, isMetaDataPanelExpanded } = this.state;

    if (loading) {
      return <LoadingSpinner />;
    }

    const isScoringRubricsAvailable = !isStudent && toogleStatus;
    const shouldEnableAudioPlaybackComplete =
      !isSingleQuestionPreview &&
      isAudioCheckEnabled(
        enableAudioPlaybackComplete,
        Number.parseInt(subjectId, 10),
      );

    let annotationData;
    if (isStudent || hasTeacherAnnotation) {
      annotationData = {
        annotationRequests,
        variables: {
          assignmentId: assignmentId ? assignmentId.toString() : 'null',
        },
      };
    }
    return (
      <Fragment>
        {itemLoading && <LoadingSpinner />}
        <div
          className={cn(
            'Player-preview',
            {
              '--is-reordering': isReordering,
              '--is-metadata-panel-expanded': isMetaDataPanelExpanded,
            },
            className,
          )}
        >
          <LearnosityPlayer
            preview
            onOrderChange={onOrderChange}
            isReordering={isReordering}
            responsiveView={ResponsiveView}
            mobileMedia={MobileMedia}
            itemId={itemId}
            questionId={newQuestionItemId || questionIdQuery}
            questionIds={questions.map((q) => q.itemId)}
            subjectId={subjectId}
            learnosityServerData={learnosityServerData}
            readyListenerCallback={this.readyListenerCallback}
            onQuestionChanged={onQuestionChanged}
            isPreApSubject={isPreApSubject}
            allowCalculatorForItems={allowCalculatorForItems}
            navigation={navigation}
            showQuestionInfo={showQuestionInfo}
            showQuestionOverview={showQuestionOverview}
            showQuestionBookmark={showQuestionBookmark}
            showQuestionIndex={showQuestionIndex}
            showCalculatorAllowedIcon={showCalculatorAllowedIcon}
            showLargeFont={largeFontSubjects.includes(
              Number.parseInt(subjectId, 10),
            )}
            showUpdatedCharmBracelet={
              isPreApSubject
                ? showUpdatedCharmBraceletPreAP
                : showUpdatedCharmBraceletAP
            }
            showDoubleArrow={showDoubleArrow}
            assignment={this.props.assignment}
            immediateFeedbackFF={this.props.immediateFeedbackFF}
            isSingleQuestionPreview={isSingleQuestionPreview}
            toogleStatus={toogleStatus}
            params={urlParams}
            annotationData={annotationData}
            isMetaDataPanelExpanded={isMetaDataPanelExpanded}
            showGrayTopRightBarPreview={
              showGrayTopRightBarPreview && !isPreApSubject && !isStudent
            }
            enableAudioPlaybackComplete={shouldEnableAudioPlaybackComplete}
          >
            <ResponsiveView screens={['medium', 'large']}>
              {(
                <PlayerGuidelines
                  isPreApSubject={isPreApSubject}
                  questions={questions}
                  isVisible={isScoringRubricsAvailable}
                />
              ) || null}
            </ResponsiveView>
            {children}
            {!isStudent && (
              <LearnosityItemPreview
                responseAnalysis={[]}
                assignmentReport={{}}
                students={[]}
                studentUrl=""
                studentId={false}
                isStudent={false}
                showAnalysis={false}
              />
            )}
            {displayTags && (
              <LearnosityItemTags
                itemId={itemId}
                questions={questions}
                subjectId={masterSubjectId.toString()}
                questionDetailsToogleRationale={
                  this.handleQuestionDetailsToogleRationale
                }
              >
                <ItemTags
                  onLoad={(element) => {
                    setMathJaxTypeset(element);
                  }}
                  questionDetailsToogleRationale={
                    this.handleQuestionDetailsToogleRationale
                  }
                  isFinalExam={isFinalExam}
                  handleToggleExpansion={this.handleToggleExpansion}
                  showGrayTopRightBarPreview={showGrayTopRightBarPreview}
                />
              </LearnosityItemTags>
            )}
          </LearnosityPlayer>
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    userData: state.userData,
    hasTeacherAnnotation: state.featureFlag['FY-9219-teacher-annotation'],
    showUpdatedCharmBraceletAP: state.featureFlag.charm_update,
    showUpdatedCharmBraceletPreAP: state.featureFlag.charm_update_preap,
    showGrayTopRightBarPreview:
      state.featureFlag.show_gray_top_right_preview_player,
    enableAudioPlaybackComplete:
      state.featureFlag.enable_audio_playback_complete,
    showDoubleArrow: state.featureFlag.double_arrow,
    subjectData: state.subject && state.subject.data,
    immediateFeedbackFF: state.featureFlag.immediate_feedback,
  };
}

export default connect(mapStateToProps)(PreviewPlayer);
